<template>
  <div>
      <div class="row">
          <div class="col-8">
              <div class="text-left section-title" style="padding: 5px;">
                  <span class="row-table-font-margins" style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center'>
                      <template v-if="buildingId">
                          <span row-table-font-margins style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center;'> {{ buildingName}} / </span>
                      </template>
                      Credit Notes
                  </span>
                    
              </div>
          </div>
          <div class="col-4 add-button-section">
              <div class="text-right" style="padding: 5px;">
                  <!--<span style="margin-right:5px">Add New Unit</span>
            <router-link class="btn btn-table" :to="{
      name: 'property',
      params: { buildingId: buildingId, buildingName: buildingName },
    }"><i class="fas fa-plus"></i></router-link>-->
                  <span style="
width: 30px;
height: 30px;
border-radius: 5px;
            background-color: #007DFC;
            color: white;
            display: inline-block;
            padding-left: 5px;
            padding-right: 5px;
            text-align: center;
            margin-right:8px;
          ">
                      <i class="fa fa-sliders-h" style="margin-top:7px;transform: rotate(-90deg);" aria-hidden="true"></i>
                  </span>
                  <div style="display:inline">
                      <span @click="showModalTemp()"
                            style="
          width: 30px;
          height: 30px;
          border-radius: 5px;
          background-color: #212121;
          color: white;
          display: inline-block;
          padding-left: 5px;
          padding-right: 5px;
          text-align: center;
          cursor:pointer;
          margin-right: 8px;
          ">
                          <i class="fa fa-plus" style="margin-top:7px;" aria-hidden="true"></i>
                      </span>
                      <modal :scrollable="true" name="control-panel-add-form" @before-open="beforeOpen" height="auto" :minHeight="800" width="80%">

                          <div class="" id="contorlPanelAddModal" role="dialog">
                              <div class="">
                                  <!-- Modal content-->
                                  <div class="modal-content">
                                      <div style="padding:15px;">
                                          <div class="row">
                                              <div class="col-8">
                                                  <div class="text-left section-title" style="padding: 5px;">
                                                      <span class="row-table-font-margins" style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center'>
                                                          <template v-if="buildingId">
                                                              <span row-table-font-margins style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center;'> {{ buildingName}} / </span>
                                                          </template>
                                                          Form
                                                      </span>
                                                  </div>
                                              </div>
                                              <div class="col-4">
                                                  <div class="text-right" style="padding: 5px;">
                                                      <a style="margin-left:6px;display:inline-block;" class="btn btn-table" @click.prevent="hide()"><i class="fas fa-times"></i></a>
                                                  </div>
                                              </div>
                                          </div>
                                          <div class="row">
                                              <div class="col-md-6">

                                              </div>
                                          </div>
                                          <creditnote-additionalexpense-form  :building-id="buildingId" :expense-id="expenseId" :amount ="amount"></creditnote-additionalexpense-form>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </modal>
                  </div>
                  <span @click="showSearch()"
                        style="
                          width: 30px;
                          height: 30px;
                          border-radius: 5px;
                          background-color: #007DFC;
                          color: white;
                          display: inline-block;
                          padding-left: 5px;
                          padding-right: 5px;
                          text-align: center;
                          cursor:pointer;

                          ">
                      <i class="fa fa-search" style="margin-top:7px;" aria-hidden="true"></i>
                  </span>

                  <input type="text" v-if="visibleSearch" class="form-control" name="searchText" id="searchText" style=" display: inline-block; width: 250px; height: 30px;" v-model="filter">
                  <userMenu />
              </div>
          </div>

      </div>
   

    <div  v-if="false" class="row">
      <div class="col-lg-3 col-md-3 col-sm-5 col-12">
        <div class="size">
          Show
          <select class="size-select" v-model="size">
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
          </select>
          Entries
        </div>
      </div>
      <div class="col-lg-9 col-md-9 col-sm-7 col-12">
        <div class="sortBy" style="margin-right: 0px;">
          Sort By
          <select class="sortBy-select" v-model="sortBy">
            <option value="Date">Date</option>
            <option value="Amount">Amount</option>
          </select>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table table-condensed">
        <thead>
            <tr>
                <th scope="col">No</th>
                <th scope="col">Credit Note Number</th>
                <th scope="col">Credit Note Date</th>
                <th scope="col">Amount</th>
              </tr>
        </thead>

        <tbody>
            <tr v-for="(payment, key) in paginatedData"
                v-bind:key="payment"
                class="clickable-row">
                <td scope="row">{{ ++key }}</td>
                <td>{{ payment.documentNumber }}</td>
                <td>{{ customFormatter(payment.date) }}</td>
                <td>{{ $filters.currency(payment.amount, "€") }}</td>
                
            </tr>
        </tbody>
      </table>
    </div>
    <div class="row">
      <div class="col-12">
        <a
          @click="$router.go(-1)"
          class="btn btn-cancel"
          style="
            width: 60px;
            display: block;
            margin-left: 30px;
            margin-right: 0;
            margin-bottom: 15px;
           
          "
          >Back</a
        >
      </div>
      <div class="col-8 table-summary">
        <span>
          Showing {{ startEntry }} to {{ endEntry }} of
          {{ numberOfEntries }} entries
        </span>
      </div>
      <div class="col-4">
        <paginate
          :page-count="numberOfPages"
          :page-range="3"
          :margin-pages="2"
          :click-handler="clickCallback"
          :prev-text="'<'"
          :next-text="'>'"
          :container-class="'pagination'"
          :page-class="'page-item'"
        >
        </paginate>
      </div>
    </div>
  </div>
</template>
<script>
import { format, parseISO } from "date-fns";
import { mapState } from "vuex";
export default {
  data: function () {
    return {
      size: 10,
      sortBy: "Date",
      filter: "",
      pageNumber: 0,
        creditNotes: [],
        expenseId: 0,
      amount:0,
      //buildingId: 0,

     // propertyName: "",
   //   propertyId: 0,
      month: 0,
      year: 0,
      contact: [],
    };
  },
  mounted() {
    this.ensureBuilding();
    //this.buildingId = this.$route.params.buildingId;
    //this.buildingName = this.$route.params.buildingName;
    //this.propertyId = this.$route.params.propertyId;
    //this.propertyName = this.$route.params.propertyName;
    if(this.$route.params.propertyName != null && this.$route.params.propertyName.length > 0)
      this.$store.commit('property/SET_CURRENT_PROPERTY_NAME', this.$route.params.propertyName)
    if(this.$route.params.propertyId != null && this.$route.params.propertyId > 0)
      this.$store.commit('property/SET_CURRENT_PROPERTY_ID', this.$route.params.propertyId)
    this.month = this.$route.params.month;
      this.year = this.$route.params.year;
      this.expenseId = this.$route.params.expenseId;
      this.amount = this.$route.params.amount;
      this.monthly = this.$route.params.monthly;
      console.log(this.paymentId);
    //this.buildingName = this.$route.params.buildingName;
    this.fetchStatement();
    this.getProperty();
  },
        methods: {
            ensureBuilding() {
              const id = Number(this.$route.params.buildingId);
              if (id > 0 && Number(this.building && this.building.id) !== id) {
                this.$store.dispatch("building/fetchBuilding", id);
              }
            },
            showModal() {
                this.isModalVisible = true;
            },
            closeModal() {
                this.isModalVisible = false;
            },
    fetchStatement: function () {
      this.mute = true;
      //this.buildingId = 3;
        var request = "/creditnote/expenses?id=" + this.expenseId + "&monthly=" + this.monthly;
      if (this.month) request += "&month=" + this.monthly + "&year=" + this.year;
      this.$http
        .get(request, {
          id: this.buildingId,
        })
        .then(({ data }) => {
          this.mute = false;
          //this.contacts = data.contacts;
          this.creditNotes = data.creditNotes;
        });
            },
            showModalTemp: function () {
                this.$modal.show("control-panel-add-form");
                //alert("Id " + expenseId + " month " + month);
                //this.isModalVisible = true;
            },
            show() {
                this.$modal.show("control-panel-add-form");
            },
            hide() {

                this.$modal.hide("control-panel-add-form");
            },
    clickCallback(pageNum) {
      this.pageNumber = pageNum - 1;
    },
    editItem: function (item) {
      this.$router.push({
        name: "committee",
        params: {
          id: item.id,
          buildingId: this.buildingId,
          buildingName: this.buildingName,
        },
      });
    },
    deleteItem: function destroy(item) {
      var r = confirm("Are you sure you want to delete committee member?");
      if (r == true) {
        var _this = this;
        this.axios.delete("/committees/" + item.id).then(function () {
          _this.fetchStatement();
          // _this.getVueItems();
          //_this.hasDeleted = false
        });
      }
    },
    customFormatter(date) {
      return format(parseISO(date), "dd/MM/yyyy");
    },
    getProperty: function () {
      this.$http.get("/properties/" + this.propertyId).then((response) => {
        this.contact = response.data.contact;
      });
    },
  },
  computed: {
    ...mapState({
      building: (state) => state.building.currentBuilding,
      propertyName:(state) => state.property.currentPropertyName,
      propertyId:(state) => state.property.currentPropertyId,
      buildings: (state) => state.building.buildings,
      numberOfAllowedBuildings: (state) =>
        state.building.numberOfAllowedBuildings,
    }),
    buildingName(){
      if(this.building != null)
        return  this.building.name;
      return ""
    },
    buildingId(){
      if(this.$route.params.buildingId)
        return this.$route.params.buildingId;
      if(this.building != null)
        return  this.building.id;
      return ""
    },
    getPayments() {
        if (!this.creditNotes) return null;
      var payments = this.creditNotes;

      return payments;
    },

    numberOfEntries() {
      return this.getPayments.length;
    },
    numberOfPages() {
      let l = this.numberOfEntries,
        s = this.size;
      return Math.ceil(l / s);
    },
    startEntry() {
      if (this.numberOfEntries == 0) {
        return 0;
      }
      if (this.pageNumber + 1 == 1) {
        return 1;
      } else {
        return this.pageNumber * this.size + 1;
      }
    },
    endEntry() {
      if (this.numberOfEntries <= this.size) {
        return this.numberOfEntries;
      } else if (this.numberOfEntries > this.size && this.pageNumber + 1 == 1) {
        return this.size;
      } else if (this.numberOfEntries > this.size && this.pageNumber + 1 > 1) {
        if (this.numberOfEntries - this.size * (this.pageNumber + 1) > 0) {
          return this.size * (this.pageNumber + 1);
        } else {
          return this.numberOfEntries;
        }
      } else {
        return NaN;
      }
    },

    paginatedData() {
      var payments = [...this.getPayments];
      const start = this.pageNumber * this.size,
        end = start + this.size;

      if (this.sortBy == "Date") {
        payments.sort((a, b) =>
          a.paidDate < b.paidDate ? 1 : b.paidDate < a.paidDate ? -1 : 0
        );
      } else {
        payments.sort((a, b) =>
          a.amount < b.amount ? 1 : b.amount < a.amount ? -1 : 0
        );
      }
      return payments.slice(start, end);
    },
  },
};
</script>
